var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import i18next from "i18next";
import { BookModel } from "../BookModel";
var UserModel = /** @class */ (function (_super) {
    __extends(UserModel, _super);
    function UserModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserModel.prototype.getTrainer = function () {
        var _this = this;
        return {
            id: this.id,
            avatarUrl: this.get("presented.profilePicture"),
            label: i18next.t("course_table.trainer_name", Object.defineProperties({}, {
                firstName: {
                    enumerable: true,
                    get: function () {
                        return _this.get("presented.firstName");
                    }
                },
                lastName: {
                    enumerable: true,
                    get: function () {
                        return _this.get("presented.lastName");
                    }
                },
                title: {
                    enumerable: true,
                    get: function () {
                        return _this.get("presented.title");
                    }
                },
                salutation: {
                    enumerable: true,
                    get: function () {
                        return _this.get("presented.salutation");
                    }
                },
                email: {
                    enumerable: true,
                    get: function () {
                        return _this.get("username");
                    }
                },
            }))
        };
    };
    return UserModel;
}(BookModel));
export { UserModel };
